// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-container{height:100%}.report-container .report-period{display:none}", ""]);
// Exports
module.exports = exports;
